import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // Make sure to use this for navigation

const Upload = () => {
  const [email, setUsername] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate(); // Use useNavigate hook for redirection


  const emailStored = localStorage.getItem('akjodem_email');
  const loggedInStored = localStorage.getItem('akjodem_isLoggedIn');

  useEffect(() => {
    if (!emailStored && !loggedInStored) {
      navigate('/login');
    }
  }, []);


  const handleLogout = () => {
    fetch('https://akjodem.com/logout.php', {
      method: 'GET',
      credentials: 'include', // Include session cookies
    })
      .then(() => {
        // Redirect to login page after logging out
        localStorage.removeItem('akjodem_email');
        localStorage.removeItem('akjodem_isLoggedIn');
        window.location.href = '/login';
      })
      .catch(error => {
        console.error('Error:', error);
      });
  };

  return (
    <>
      <div>
        <h2>{message}</h2>
        {email && <p>Logged in as: {email}</p>}
      </div>
      <div onClick={handleLogout}>Logout</div>
    </>
  );
};

export default Upload;
